import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Component } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FormattedMessage, injectIntl } from 'react-intl-next';
import AkButton from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import FocusLock from 'react-focus-lock';
import { messages } from '../i18n';
import CachingEmoji from './CachingEmoji';
import EmojiErrorMessage, { emojiErrorScreenreaderTestId } from './EmojiErrorMessage';
import RetryableButton from './RetryableButton';
import { deleteFooter, deletePreview, deleteText, emojiDeleteErrorMessage, previewButtonGroup } from './styles';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { fg } from '@atlaskit/platform-feature-flags';
export var emojiDeletePreviewTestId = 'emoji-delete-preview';
var deleteEmojiLabelId = 'fabric.emoji.delete.label.id';
var EmojiDeletePreview = /*#__PURE__*/function (_Component) {
  function EmojiDeletePreview(props) {
    var _this;
    _classCallCheck(this, EmojiDeletePreview);
    _this = _callSuper(this, EmojiDeletePreview, [props]);
    _defineProperty(_this, "onSubmit", function () {
      var _this$props = _this.props,
        emoji = _this$props.emoji,
        onDeleteEmoji = _this$props.onDeleteEmoji,
        onCloseDelete = _this$props.onCloseDelete;
      if (!_this.state.loading) {
        _this.setState({
          loading: true
        });
        onDeleteEmoji(emoji).then(function (success) {
          if (success) {
            onCloseDelete();
            return;
          }
          _this.setState({
            loading: false,
            error: true
          });
        });
      }
    });
    _defineProperty(_this, "onCancel", function () {
      _this.props.onCloseDelete();
    });
    _this.state = {
      loading: false,
      error: false
    };
    return _this;
  }
  _inherits(EmojiDeletePreview, _Component);
  return _createClass(EmojiDeletePreview, [{
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps) {
      if (!fg('platform_editor_react18_elements_emoji')) {
        if (nextProps.emoji.id !== this.props.emoji.id) {
          this.setState({
            error: false
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (fg('platform_editor_react18_elements_emoji')) {
        if (prevProps.emoji.id !== this.props.emoji.id) {
          this.setState({
            error: false
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        emoji = _this$props2.emoji,
        intl = _this$props2.intl;
      var _this$state = this.state,
        loading = _this$state.loading,
        error = _this$state.error;
      var formatMessage = intl.formatMessage;
      return jsx(FocusLock, {
        noFocusGuards: true
      }, jsx("div", {
        css: deletePreview,
        "data-testid": emojiDeletePreviewTestId
      }, jsx("div", {
        css: deleteText
      }, jsx(Heading, {
        size: "xxsmall"
      }, jsx(FormattedMessage, messages.deleteEmojiTitle)), jsx(FormattedMessage, _extends({}, messages.deleteEmojiDescription, {
        values: {
          emojiShortName: emoji.shortName
        }
      }))), jsx("div", {
        css: deleteFooter
      }, jsx(CachingEmoji, {
        emoji: emoji
      }), jsx("div", {
        css: previewButtonGroup
      }, error ? !loading ? jsx(EmojiErrorMessage, {
        message: formatMessage(messages.deleteEmojiFailed),
        messageStyles: emojiDeleteErrorMessage,
        tooltip: true
      }) : null : null, jsx(VisuallyHidden, {
        id: deleteEmojiLabelId
      }, formatMessage(messages.deleteEmojiLabel)), jsx(RetryableButton, {
        label: formatMessage(messages.deleteEmojiLabel),
        onSubmit: this.onSubmit,
        appearance: "danger",
        loading: loading,
        error: error,
        ariaLabelledBy: "".concat(emojiErrorScreenreaderTestId, " ").concat(deleteEmojiLabelId)
      }), jsx(AkButton, {
        appearance: "subtle",
        onClick: this.onCancel
      }, jsx(FormattedMessage, messages.cancelLabel))))));
    }
  }]);
}(Component);
export default injectIntl(EmojiDeletePreview);